/* eslint-disable global-require */
const awsIntFdr = require("../aws-int/fdr");

module.exports = {
  ...awsIntFdr,
  domain: {
    desktop: "racing.perf.use2.racing.fndlext.net",
    mobile: "racing.perf.use2.racing.fndlext.net",
    talentPicks: "racing.perf.use2.racing.fndlext.net/talent-picks/",
    accountWallet: "account.racing.perf.use2.racing.fndlext.net",
    equibase: "equibase-store.perf.use2.racing.fndlext.net"
  },
  service_host: "api.racing.perf.use2.racing.fndlext.net",
  externalDomain: {
    FDTermsConditions: "https://www.perf.use2.racing.fndlext.net/terms",
    FDPolicy: "https://www.perf.use2.racing.fndlext.net/privacy",
    FDRLoginBridge:
      "https://www.perf.use2.racing.fndlext.net/sso-auth/fdracing",
    FDRSignup:
      "https://www.perf.use2.racing.fndlext.net/join?next=%2Fsso-auth%2Ffdracing%3Fredirect_uri%3D"
  },
  externalServices: {
    fanduel: "https://api.perf.use2.racing.fndlext.net",
    cpp: "https://promos-api.perf.use2.racing.fndlext.net"
  }
};
